var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-hospital-admin"},[_c('h1',[_vm._v("Add Hospital Administrator")]),_c('AddHospitalAdmin',{attrs:{"customer":2},on:{"submit":_vm.create}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }